// Mapeamento de status backend <-> frontend
export const backendToFrontStatus: Record<string, string> = {
  "Em analise": "pending",
  "Em análise": "pending",
  Analise: "pending",
  Análise: "pending",
  Aprovada: "approved",
  Aprovado: "approved",
  Rejeitada: "rejected",
  Rejeitado: "rejected",
  "Algo a corrigir": "correction",
};

// Conjunto canônico vindo do backend
export const VALID_BACKEND_STATUSES = [
  "Em analise",
  "Aprovada",
  "Rejeitada",
  "Algo a corrigir",
] as const;
export type BackendStatus = (typeof VALID_BACKEND_STATUSES)[number];

export const frontToBackendStatus: Record<string, BackendStatus> = {
  pending: "Em analise",
  approved: "Aprovada",
  rejected: "Rejeitada",
  correction: "Algo a corrigir",
  // 'review' removido para evitar divergência; usar 'pending'
};

export const statusLabelPt: Record<string, string> = {
  pending: "Aguardando análise",
  approved: "Aprovada",
  rejected: "Rejeitada",
  correction: "Correção necessária",
};

export function toFrontStatus(raw?: string): string {
  if (!raw) return "pending";
  return backendToFrontStatus[raw] || raw.toLowerCase();
}

export function toBackendStatus(front: string): string {
  return frontToBackendStatus[front] || front;
}
